import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Services Section - fade in with zoom and rotation
 */
export const animateServicesSection = (ref, isLoading, servicesData) => {
  if (ref.current && !isLoading && servicesData.length > 0) {
    const element = ref.current;
    
    // Set initial state immediately to prevent flash
    gsap.set(element, { opacity: 0, scale: 0.95, rotation: -2 });
    
    const timer = setTimeout(() => {
      gsap.to(element, {
        opacity: 1,
        scale: 1,
        rotation: 0,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      });
      ScrollTrigger.refresh();
    }, 200);
    
    return () => clearTimeout(timer);
  }
};

